// =============================================
// MusicLanding — the "Your Music" tab
// =============================================
// Empty library → a marketing landing (your music everywhere, no more discs) with
// the legal/ownership warning + an "upload your first song" CTA. Has music → the
// tile dashboard (image 2).
// =============================================
import React from 'react';
import { FiUploadCloud, FiCloud, FiSmartphone, FiShield, FiDisc } from 'react-icons/fi';
import { TrackView } from './musicLibrary';
import MusicDashboard from './MusicDashboard';

interface Props {
  tracks: TrackView[];
  userId: number;
  onPlay: (tracks: TrackView[], index: number, title?: string) => void;
  currentTrackId: number | null;
  onChanged: () => void;
  showAds: boolean;
  planTier: string;
  goUpload: () => void;
}

export const MusicLanding: React.FC<Props> = (props) => {
  const { tracks, goUpload } = props;

  if (tracks.length > 0) {
    return <MusicDashboard {...props} />;
  }

  // ---- Empty-library marketing landing ----
  return (
    <div className="ml-landing">
      <div className="ml-hero">
        <div className="ml-hero-badge"><FiDisc /></div>
        <h1 className="ml-hero-title">All your music. In one place. Forever.</h1>
        <p className="ml-hero-sub">
          No more shoeboxes of CDs, scratched DVDs, or vinyl you can't play on the road.
          Bring the music you already own into your own private cloud locker — and listen
          anywhere, on any device, for as long as you keep it.
        </p>
        <button className="ml-hero-cta" onClick={goUpload}>
          <FiUploadCloud /> Upload your first song
        </button>
      </div>

      <div className="ml-features">
        <div className="ml-feature">
          <FiCloud className="ml-feature-icon" />
          <h4>Your collection, digitized</h4>
          <p>Rip your discs once, keep them forever. The locker holds the music you bought — not a rented stream.</p>
        </div>
        <div className="ml-feature">
          <FiSmartphone className="ml-feature-icon" />
          <h4>Play anywhere</h4>
          <p>Phone, laptop, tablet — your library follows you. Build playlists, rate, and rediscover what you own.</p>
        </div>
        <div className="ml-feature">
          <FiShield className="ml-feature-icon" />
          <h4>Yours, kept safe</h4>
          <p>Backed up and organized by artist, album, language and mood — so a broken disc never loses a song again.</p>
        </div>
      </div>

      <div className="ml-warning">
        <FiShield className="ml-warning-icon" />
        <div>
          <strong>Upload only music you legally own.</strong>
          <p>
            Akountant Music is a personal locker for music you have purchased or otherwise have the
            legal right to copy for your own use. Please do not upload pirated, ripped-from-streaming,
            or otherwise unauthorized files. You'll certify ownership on every upload, and we keep a
            signed record of your agreement — see the terms you accepted in the <strong>Membership</strong> tab.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MusicLanding;
